import { render, staticRenderFns } from "./index.vue?vue&type=template&id=145d6df2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145d6df2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('145d6df2')) {
      api.createRecord('145d6df2', component.options)
    } else {
      api.reload('145d6df2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=145d6df2&scoped=true", function () {
      api.rerender('145d6df2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms/index.vue"
export default component.exports